import { render, staticRenderFns } from "./combineLogisRAndP.vue?vue&type=template&id=7adf42ca&scoped=true&"
import script from "./combineLogisRAndP.vue?vue&type=script&lang=js&"
export * from "./combineLogisRAndP.vue?vue&type=script&lang=js&"
import style0 from "./combineLogisRAndP.vue?vue&type=style&index=0&id=7adf42ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf42ca",
  null
  
)

component.options.__file = "combineLogisRAndP.vue"
export default component.exports